import Image, { StaticImageData } from "next/image";

import icon_1 from "@/assets/images/icon//weight.svg";
import icon_2 from "@/assets/images/icon/icon_04.svg";
import icon_3 from "@/assets/images/icon/gender.svg";
import icon_4 from "@/assets/images/icon/register.svg";
import icon_5 from "@/assets/images/icon/event.svg";
import icon_6 from "@/assets/images/icon/ageGroup.svg";
import { formatAgeForUi, formatDateRange } from "@/utils/utils";

interface DataType {
  id: number;
  icon: StaticImageData;
  title: string;
}
[];

const property_overview_data: DataType[] = [
  {
    id: 1,
    icon: icon_1,
    title: `Weight . 3,720`,
  },
  {
    id: 2,
    icon: icon_2,
    title: `Group . 03`,
  },
  {
    id: 3,
    icon: icon_3,
    title: `Gender . 2`,
  },
  {
    id: 4,
    icon: icon_4,
    title: `Register . 01`,
  },
  {
    id: 5,
    icon: icon_5,
    title: `Event . Apartment`,
  },
  {
    id: 6,
    icon: icon_6,
    title: `Age Group . Apartment`,
  },
];

const CommonPropertyOverview = (data: any) => {
  const hasAgeData =
    data?.data?.attributes?.age_from != null &&
    data?.data?.attributes?.age_to != null;
  const isGradeGroup =
    !hasAgeData && data?.data?.attributes?.Is_Age_Grade === "Grade";
  const from = isGradeGroup
    ? parseInt(
        data?.data?.attributes?.Grade_From?.data?.attributes?.short_name || "0",
        10,
      )
    : null;
  const to = isGradeGroup
    ? parseInt(
        data?.data?.attributes?.Grade_To?.data?.attributes?.short_name || "0",
        10,
      )
    : null;

  const property_overview_data: any[] = [
    {
      id: 1,
      icon: icon_1,
      visible: data?.data?.attributes?.weight_from ? true : false,
      title: `Weight . ${data?.data?.attributes?.weight_from || "-"}  -  ${
        data?.data?.attributes?.weight_to || "-"
      }`,
    },
    {
      id: 2,
      icon: icon_2,
      visible: true,
      title:
        data?.data?.attributes?.minimum_entry !==
        data?.data?.attributes?.maximum_entry
          ? `Group . ${data?.data?.attributes?.minimum_entry || "-"}  -  ${
              data?.data?.attributes?.maximum_entry || "-"
            }`
          : data?.data?.attributes?.maximum_entry,
    },
    {
      id: 3,
      icon: icon_3,
      visible: true,

      title: `Gender . ${data?.data?.attributes?.gender || "-"}`,
    },
    {
      id: 4,
      icon: icon_4,
      visible: true,

      title: `Registration dates . ${formatDateRange(
        data?.data?.attributes?.event_register_start_date,
        data?.data?.attributes?.event_register_end_date,
      )}`,
    },
    {
      id: 5,
      icon: icon_5,
      visible: true,

      title: `Event dates . ${formatDateRange(
        data?.data?.attributes?.event_start_date,
        data?.data?.attributes?.event_end_date,
      )}`,
    },
    {
      id: 6,
      icon: icon_6,
      visible: true,
      title: isGradeGroup
        ? `Grade Group . ${data?.data?.attributes?.Grade_From?.data?.attributes?.short_name} - ${data?.data?.attributes?.Grade_To?.data?.attributes?.short_name}`
        : `Age Group . ${formatAgeForUi(
            data?.data?.attributes?.age_from || 0,
            data?.data?.attributes?.age_to || 0,
          )}`,
    },
  ];
  return (
    <ul className="list-unstyled d-flex flex-wrap align-items-center justify-content-start gap-2 px-0 m-0">
      {property_overview_data
        .filter((item) => item.visible)
        .map((item, index) => (
          <li
            key={item.id}
            className={`d-flex align-items-center gap-2 px-3 py-2 ${
              index !== 0 ? "border-start" : ""
            }`}
            style={{
              borderLeft: index !== 0 ? "1px solid #ccc" : "none",
              minWidth: "140px",
            }}
          >
            <Image
              src={item.icon}
              alt={item.title}
              className="lazy-img"
              width={24}
              height={24}
              style={{ objectFit: "contain" }}
            />
            <span
              className="text-dark"
              style={{ fontSize: "1rem", fontWeight: "500" }}
            >
              {item.title}
            </span>
          </li>
        ))}
    </ul>
  );
};

export default CommonPropertyOverview;
